import React from "react";
import { ResponsiveLine } from "@nivo/line";
import { BasicTooltip } from "@nivo/tooltip";
import { I18n } from "i18n-js";
import * as locales from "../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import MinigraphCard from "./minigraphCard";
import AnalyticsLoading from "../analyticsLoading";
import AnalyticsError from "../analyticsError";

interface ParticipationCardProps {
  devMode: boolean;
  data: any;
  fetchParticipationData: any;
  totalEngagement: number;
  requestStatus: string;
}

export default class ParticipationCard extends React.Component<
  ParticipationCardProps,
  any
> {
  componentDidMount() {
    if (this.props.requestStatus === "loading") {
      this.props.fetchParticipationData();
    }
  }

  render() {
    return (
      <MinigraphCard
        devMode={this.props.devMode}
        title={this.getTitle()}
        url={this.getUrl()}
        chartName="participation"
      >
        {this.renderContent()}
      </MinigraphCard>
    );
  }

  renderHeaderStats = () => {
    return (
      <div className="header-stats">{this.renderTotalParticipation()}</div>
    );
  };

  renderTotalParticipation = () => {
    return (
      <div>
        <div className="header-total-percent">{this.getTotalEngagement()}</div>
        <div className="header-percent-footer">
          {i18n.translate("analyticsv2.participation_card.subtitle")}
        </div>
      </div>
    );
  };

  renderContent = () => {
    if (this.props.requestStatus === "error") {
      return (
        <AnalyticsError
          error={i18n.translate("analyticsv2.something_went_wrong")}
        />
      );
    }
    if (this.props.requestStatus === "loading") {
      return <AnalyticsLoading />;
    }
    if (this.props.data.length === 0) {
      return (
        <AnalyticsError
          error={i18n.translate("analyticsv2.participation.not_enough_data")}
        />
      );
    }
    if (this.props.requestStatus === "success") {
      return (
        <>
          {this.renderHeaderStats()}
          {this.renderParticipationGraph()}
        </>
      );
    }

    return null;
  };

  renderParticipationGraph = () => {
    return (
      <div style={{ height: 200 }}>
        <ResponsiveLine
          axisBottom={null}
          axisLeft={null}
          colors={(d) => {
            return d.color;
          }}
          curve="monotoneX"
          data={this.props.data}
          enableArea
          enablePoints={false}
          enableGridX={false}
          enableGridY={false}
          legends={[]}
          lineWidth={4}
          margin={{
            top: 10,
            right: 0,
            bottom: 0,
            left: 0,
          }}
          pointLabel="y"
          pointLabelYOffset={-12}
          useMesh
          xScale={{ type: "point" }}
          yScale={{
            type: "linear",
            stacked: true,
            min: 0,
            max: 100,
          }}
          tooltip={({ point }) => {
            return (
              <BasicTooltip
                id={
                  <span>
                    {point.data.xFormatted}:{" "}
                    <strong>{point.data.yFormatted}%</strong>
                  </span>
                }
              />
            );
          }}
          theme={{
            tooltip: {
              basic: {
                color: "#fefefe",
                fontWeight: "bold",
              },
              container: {
                background: "#333",
                opacity: 0.85,
                padding: 8,
              },
            },
          }}
        />
      </div>
    );
  };

  getTotalEngagement = () => {
    return `${this.props.totalEngagement}%`;
  };

  getTitle = () => {
    return "Participation";
  };

  getUrl = () => {
    return "/analytics/engagement";
  };
}
